export default function membershipBlock() {
    const $categories = $(".membership__category-item");
    const $imageContainer = $(".membership__image img");
    const $helper = $(".membership__pulse--helper");
    const $membershipSlider =  $(".membership__pulse-items");
    const $pagerContainer = $('.membership-pulse__pagination');
    const $prevButton = $('.membership-pulse--arrow--prev');
    const $nextButton = $('.membership-pulse--arrow--next');

    $categories.each(function () {
        $(this).on("click", function () {
            const $this = $(this);
            const defaultImage = $this.data("default");
            const activeImage = $this.data("active");
            
            // First, remove active class from all categories
            $categories.removeClass("active");
            
            // Then add active class to the clicked category
            $this.addClass("active");
            
            // Update image to the active image of the clicked category
            $imageContainer.attr("src", activeImage);
        });
    });

    // Slick Slider for mobile (NCODA Pulse)
    if ( $helper.css('display') !== 'none') {
        $membershipSlider.slick({
            dots: true,
            arrows: true,
            arrowsPlacement: 'afterSlides',
            prevArrow: $prevButton,
            nextArrow: $nextButton,
            appendDots: $pagerContainer,
            dotsClass: 'slick--pagination', // Slick generates a <ul.carousel-pagination> within the appendDots container
            customPaging: function (slider, i) {
                const slideNumber = (i + 1);
                const totalSlides = slider.slideCount;
                return '<button class="pagination-control"><span class="visually-hidden">View slide ' + slideNumber + ' of ' + totalSlides + '</span></button>';
            },
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ],
        });
    }
    
    // Handle window resize for the slider
    $(window).on('resize', function() {
        if ( $helper.css('display') !== 'none') {
            // Initialize slider if it hasn't been initialized
            if (!$membershipSlider.hasClass('slick-initialized')) {
                $membershipSlider.slick({
                    dots: true,
                    arrows: true,
                    arrowsPlacement: 'afterSlides',
                    prevArrow: $prevButton,
                    nextArrow: $nextButton,
                    appendDots: $pagerContainer,
                    dotsClass: 'slick--pagination', // Slick generates a <ul.carousel-pagination> within the appendDots container
                    customPaging: function (slider, i) {
                        const slideNumber = (i + 1);
                        const totalSlides = slider.slideCount;
                        return '<button class="pagination-control"><span class="visually-hidden">View slide ' + slideNumber + ' of ' + totalSlides + '</span></button>';
                    },
                    infinite: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1
                            }
                        },
                    ],
                });
            }
        } else {
            // Destroy slider if it's initialized and window is wider than 768px
            if ($membershipSlider.hasClass('slick-initialized')) {
                $membershipSlider.slick('unslick');
            }
        }
    });
}